import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type SidebarStore = {
	isSidebarOpened: boolean;
	openedMenuList: string | null;
	isLocked: boolean;
	previousSidebarOpened: boolean | null;
};

type SidebarActions = {
	toggleSidebar: () => void;
	toggleMenuList: (menuListId: string | null) => void;
	lockSidebarClosed: () => void;
	unlockSidebar: () => void;
};

const initialState: SidebarStore = {
	isSidebarOpened: true,
	openedMenuList: null,
	isLocked: false,
	previousSidebarOpened: null,
};

const sidebarStore = create<SidebarStore & SidebarActions>()(
	persist(
		(set, get) => ({
			...initialState,
			toggleSidebar: () => {
				if (get().isLocked) return;
				set(() => ({ isSidebarOpened: !get().isSidebarOpened }));
			},
			toggleMenuList: (menuListId) =>
				set(({ openedMenuList }) => ({
					openedMenuList: openedMenuList === menuListId ? null : menuListId,
				})),
			lockSidebarClosed: () => {
				if (get().isLocked) return;
				set(({ isSidebarOpened }) => ({
					isLocked: true,
					previousSidebarOpened: isSidebarOpened,
					isSidebarOpened: false,
					openedMenuList: null,
				}));
			},
			unlockSidebar: () => {
				if (!get().isLocked) return;
				set(({ previousSidebarOpened }) => ({
					isLocked: false,
					isSidebarOpened: previousSidebarOpened ?? true,
					previousSidebarOpened: null,
				}));
			},
		}),
		{
			name: 'sidebarStore',
			partialize: ({ isSidebarOpened, openedMenuList }) => ({ isSidebarOpened, openedMenuList }),
		},
	),
);

export const useSidebarStore = () => sidebarStore((state) => state);
